module.exports = __webpack_public_path__ + "img/bg03.625539d3.jpg";